import React, {useEffect} from "react";
import {
  Box,
  Paper,
  useMediaQuery,
  useTheme
} from "@mui/material";
import TabsComponent from "../Tabs";
import SelectComponent from "../Select";
import { useAppContext } from "../../context";
import Courses from "../courses";
import PopUp from "../PopUp";
import DialogComponent from "../Dialog";
import CalculateCourseComponent from "../CalculateCourse";
import { useLazyGetRatesByProductQuery, useGetRatesQuery } from "../../store/api/conversionApi";
import { currencyBuyRateData, currencySellRateData, getRatesData } from "../../Functions";
import Verification from "../Verification";
import VerifyError from "../Verification/VerifyError";


export default function FilterHeader() {
  const {
    showDropdown,
    openPopUp,
    setOpenPopUp,
    setCurrencySellRates,
    setCurrencyBuyRates,
    setCurrence,
    tab,
    product,
    city,
    setCurrentRateData,
    setCurrencyData,
    setOfficialCourse,
    setBank,
    setCreateOrder,
    setStep,
    popupContent,
    errorMsg
  } = useAppContext();

  // const [isLoad, setIsLoad] = React.useState(true);
  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down("md")); // < 900px

  const onlineRates = useGetRatesQuery(undefined, {
    skip: tab !== 2,
  });


    const [triggerRates, cashlessRates] = useLazyGetRatesByProductQuery();
    
    useEffect(() => {
        if (tab === 2) return;

        triggerRates({
            isCash: tab === 0,
        });
    }, [tab, triggerRates]);


    useEffect(() => {
        if (tab === 2) return;
        if (!product && !city) return;

        triggerRates({
            isCash: tab === 0,
            ...(product ? { RateProductID: product } : {}),
            ...(city ? { RateCityID: city } : {}),
        });
    }, [product, city, tab, triggerRates]);

    useEffect(() => {
        const rates = tab === 2 ? onlineRates.data : cashlessRates.data;
        if (!rates) return;
        const hasNbgRate = rates.some((r: any) => Boolean(r?.NBGRate));
        setOfficialCourse(hasNbgRate);
        
        const data = getRatesData(rates);
        setCurrentRateData(data);
        // if (data) setIsLoad(false);
    }, [tab, onlineRates.data, cashlessRates.data, setOfficialCourse, setCurrentRateData]);


  const clearAll = () => {

    // 🧠 რომელ data-ს ვხმარობთ
    const ratesData =
      tab === 2 ? onlineRates.data : cashlessRates.data;

    const isSuccess =
      tab === 2 ? onlineRates.isSuccess : cashlessRates.isSuccess;



    if (!isSuccess || !ratesData?.length) {
      setCurrencyData(false);
      setCurrentRateData([]);
      return;
    }

    setCurrencyData(true);

    setCurrence(
      Array.from(
        Array.from(
          new Set(
            tab !== 2 ?
              ratesData.flatMap((r: any) => [r.SourceISO, r.TargetISO])
              :
              ratesData.flatMap((r: any) => [r.sourceCurrency, r.targetCurrency])
          )
        ).sort()
      )
    );


    const sellRates: any = currencySellRateData(ratesData, tab);

    const buyRates: any = currencyBuyRateData(ratesData, tab);

    // Ensure sellRates is an object with string keys and number values
    setCurrencySellRates(sellRates);
    setCurrencyBuyRates(buyRates);


    ratesData?.forEach((rate: any) => {

      const hasNbgRate = Boolean(rate?.NBGRate);

      hasNbgRate ? setOfficialCourse(hasNbgRate) : setOfficialCourse(false);

    })

    const data = getRatesData(ratesData);

    setCurrentRateData(data);
    setBank(0);
    // setCreateOrder({
    //   sourceCurrency: "USD",
    //     targetCurrency: "GEL",
    //     amount: null,
    //     result: null,
    //     openBankingLinkProvider: null,
    //     bankAccount: [],
    //     isChecked: false,
    // });
    setStep(1);
  }

  // if (!isLoad) return <Loader />;
  return (
    <>
    {/* {!isLoad && <Loader />} */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          gap: 2,
          borderRadius: 2,
          border: "1px solid #eee",
          boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)"
        }}
      >
        {/* LEFT SIDE – TABS */}

        <TabsComponent isMobile={isMobile} />
        {/* RIGHT SIDE – SELECT FIELDS */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            width: isMobile ? "100%" : "auto",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          {showDropdown && <SelectComponent isMobile={isMobile} />}

        </Box>
      </Paper>
      <Box sx={{ mt: 2, width: "100%", height: "auto" }}>
        <Courses />
      </Box>
      <PopUp open={openPopUp} onClose={() => { setOpenPopUp(false); clearAll() }} >
        {popupContent === "Verification" && <Verification />}
        {popupContent === "ErrorMessage" && <VerifyError title={errorMsg.title} message={errorMsg.message} link={errorMsg?.link} />}
        {popupContent === "Dialog" && <DialogComponent />}
        {popupContent === "Calculate" && <CalculateCourseComponent mode="POPUP" />}
      </PopUp>

    </>
  );
}
